import { combineReducers } from 'redux'
import edit from './edit'
import detail from './detail'

export default combineReducers({
  edit,
  detail,
})
